export const ru = {
  meta: { langName: 'Русский', short: 'RU' },
  common: {
    tagline: 'Watch together. Feel closer.',
    createRoom: 'Создать комнату',
    joinRoom: 'Войти в комнату',
    join: 'Войти',
    cancel: 'Отмена',
    save: 'Сохранить',
    retry: 'Повторить',
    home: 'На главную',
    copy: 'Копировать',
    copied: 'Скопировано',
    close: 'Закрыть',
    loading: 'Загрузка…',
    you: 'вы',
  },
  landing: {
    navHow: 'Как это работает',
    navPrivacy: 'Приватность',
    eyebrow: 'Комнаты для совместного просмотра',
    title: 'Смотрите вместе.\nДаже на расстоянии.',
    subtitle:
      'Одна комната, одно видео, одна секунда. Синхронное воспроизведение, голос, камеры и чат — без регистрации и без установки.',
    quickJoinLabel: 'Ссылка-приглашение или код комнаты',
    quickJoinPlaceholder: 'Вставьте ссылку приглашения',
    quickJoinInvalid: 'Не похоже на ссылку VYBE. Проверьте приглашение.',
    demoLabel: 'Так выглядит комната VYBE',
    demoNowPlaying: 'Сейчас в комнате',
    demoSynced: 'Синхронизировано',
    demoChat1: 'Этот момент 🔥',
    demoChat2: 'Поставь на паузу, сейчас вернусь',
    featuresTitle: 'Всё, что нужно для вечера вместе',
    features: [
      {
        title: 'Синхронный просмотр',
        text: 'Пауза, перемотка и воспроизведение одновременно у всех. Сервер держит единое состояние.',
      },
      {
        title: 'Голос и камеры',
        text: 'Прямое WebRTC-соединение между участниками. Камера включается только по вашему нажатию.',
      },
      {
        title: 'Чат и реакции',
        text: 'Пишите во время фильма, отвечайте реакциями — не отрываясь от экрана.',
      },
      {
        title: 'Почти любые ссылки',
        text: 'MP4, WebM, HLS, DASH, YouTube, Vimeo и встраиваемые плееры. VYBE сам определит тип.',
      },
    ],
    stepsTitle: 'Три шага до сеанса',
    steps: ['Создайте комнату', 'Вставьте ссылку на видео', 'Отправьте приглашение'],
    privacyTitle: 'Приватность по умолчанию',
    privacy: [
      'Разговоры и видео с камер идут напрямую между участниками и никогда не записываются.',
      'Приватные комнаты открываются только по криптографически стойкой ссылке-приглашению.',
      'Регистрация не нужна: гостевой профиль живёт только на время сессии.',
      'VYBE не скачивает и не проксирует видео — ссылка воспроизводится напрямую в вашем браузере.',
    ],
    footer: 'VYBE — платформа для совместного просмотра.',
    footerNote: 'Используйте только контент, который вы имеете право смотреть и показывать.',
  },
  create: {
    title: 'Новая комната',
    description: 'Настройки можно изменить позже.',
    name: 'Название комнаты',
    namePlaceholder: 'Киновечер',
    defaultName: 'Киновечер',
    private: 'Приватная комната',
    privateHint: 'Вход только по ссылке-приглашению',
    maxParticipants: 'Участников',
    control: 'Управление видео',
    controlHost: 'Только ведущий',
    controlShared: 'Все участники',
    voice: 'Голосовой чат',
    camera: 'Камеры',
    submit: 'Создать',
    failed: 'Не удалось создать комнату. Проверьте соединение и попробуйте снова.',
  },
  name: {
    title: 'Как вас называть?',
    description: 'Имя увидят другие участники комнаты.',
    label: 'Ваше имя',
    placeholder: 'Например, Аня',
    continue: 'Продолжить',
    invitedTo: 'Вас пригласили в комнату',
    privateRoom: 'Приватная комната',
  },
  room: {
    connecting: 'Подключаемся к комнате…',
    reconnecting: 'Соединение потеряно. Переподключаемся…',
    reconnected: 'Соединение восстановлено',
    invite: 'Пригласить',
    inviteCopied: 'Ссылка-приглашение скопирована',
    leave: 'Выйти',
    endRoom: 'Завершить комнату',
    endConfirm: 'Завершить комнату для всех участников?',
    theater: 'Режим кинотеатра',
    exitTheater: 'Обычный режим',
    tabs: { chat: 'Чат', people: 'Участники', settings: 'Настройки' },
    roles: { owner: 'Владелец', moderator: 'Модератор', participant: 'Участник' },
    away: 'переподключается',
    makeModerator: 'Сделать модератором',
    removeModerator: 'Снять модератора',
    kick: 'Удалить из комнаты',
    hostControls: 'Видео управляет ведущий',
    sharedControls: 'Управлять могут все',
    settingsSaved: 'Настройки сохранены',
    errors: {
      not_found: {
        title: 'Комната не найдена',
        text: 'Возможно, она завершена или ссылка устарела.',
      },
      invalid_invite: {
        title: 'Приглашение недействительно',
        text: 'Попросите владельца прислать ссылку ещё раз.',
      },
      room_full: { title: 'Комната заполнена', text: 'Достигнут лимит участников.' },
      forbidden: { title: 'Доступ закрыт', text: 'Вас удалили из этой комнаты.' },
      rate_limited: {
        title: 'Слишком много попыток',
        text: 'Подождите немного и попробуйте снова.',
      },
      unknown: {
        title: 'Не удалось подключиться',
        text: 'Проверьте интернет и попробуйте ещё раз.',
      },
    },
    closed: {
      title: 'Комната завершена',
      owner_closed: 'Владелец завершил сеанс.',
      expired: 'Комната закрыта по истечении времени.',
      kicked: 'Вас удалили из комнаты.',
      replaced: 'Комната открыта в другой вкладке или на другом устройстве.',
    },
    actionErrors: {
      forbidden: 'Недостаточно прав для этого действия',
      rate_limited: 'Слишком часто. Подождите секунду',
      generic: 'Действие не выполнено. Попробуйте снова',
    },
  },
  source: {
    label: 'Ссылка на видео',
    placeholder: 'Вставьте ссылку: страница сериала, MP4, HLS, YouTube, Vimeo…',
    apply: 'Смотреть',
    change: 'Сменить видео',
    detected: 'Определено',
    kinds: {
      file: 'Видеофайл',
      hls: 'HLS-поток',
      dash: 'MPEG-DASH',
      youtube: 'YouTube',
      vimeo: 'Vimeo',
      twitch: 'Twitch',
      rutube: 'Rutube',
      vk: 'VK Видео',
      embed: 'Встраиваемый плеер',
      page: 'Страница сайта',
      unknown: 'Неизвестный формат',
    },
    status: {
      ready: 'Источник готов',
      loading: 'Подключаем источник…',
    },
    errors: {
      invalid_url: {
        title: 'Это не ссылка',
        text: 'Вставьте полный адрес, начинающийся с https://',
      },
      embed_blocked: {
        title: 'Источник запрещает встраивание',
        text: 'Владелец видео отключил просмотр на сторонних сайтах. Попробуйте другую ссылку.',
      },
      auth_required: {
        title: 'Источник требует авторизации',
        text: 'Видео закрыто логином, подпиской или токеном. VYBE не обходит такую защиту.',
      },
      unsupported_format: {
        title: 'Формат не поддерживается',
        text: 'Браузер не может воспроизвести этот файл. Подойдут MP4 (H.264), WebM, HLS или DASH.',
      },
      unavailable: {
        title: 'Видео недоступно',
        text: 'Файл не найден, удалён или сервер не разрешает воспроизведение с других сайтов (CORS).',
      },
      drm: {
        title: 'Видео защищено DRM',
        text: 'Защищённый контент нельзя воспроизвести в общей комнате.',
      },
      network: {
        title: 'Соединение потеряно',
        text: 'Не удаётся загрузить видео. Проверьте интернет.',
      },
      timeout: {
        title: 'Источник не отвечает',
        text: 'Видео не загрузилось за отведённое время. Проверьте ссылку.',
      },
    },
    capability: {
      auto: 'Автоматическая синхронизация',
      manual: 'Ручная синхронизация по общему таймкоду',
      manualPage: 'Ручная синхронизация (если сайт разрешает встраивание)',
      blocked: 'Встраивание запрещено сайтом — только ручная синхронизация',
      unknown:
        'Режим синхронизации станет ясен после загрузки: видеофайл — автоматическая, страница — ручная',
      caveats: {
        rutube:
          'Реклама Rutube показывается каждому отдельно: пока она идёт, зритель может отстать, а пауза, нажатая рядом с рекламой, не передаётся. После рекламы VYBE возвращает его к общему времени.',
      },
      degraded: {
        play: 'Плеер не начал воспроизведение по команде VYBE, поэтому у вас включена ручная синхронизация: нажимайте Play в самом плеере по общему таймкоду.',
        pause:
          'Плеер не остановился по команде VYBE, поэтому у вас включена ручная синхронизация по общему таймкоду.',
        seek: 'Плеер не перешёл к нужному моменту по команде VYBE, поэтому у вас включена ручная синхронизация по общему таймкоду.',
        time: 'Плеер не сообщает текущее время, поэтому у вас включена ручная синхронизация по общему таймкоду.',
      },
    },
    nextStep:
      'Что подойдёт: прямая ссылка на MP4/WebM, поток .m3u8 или .mpd, видео YouTube, Vimeo, VK Видео или Rutube.',
    empty: {
      title: 'Видео ещё не выбрано',
      host: 'Вставьте ссылку выше — VYBE сам определит тип источника.',
      guest: 'Ведущий скоро выберет, что смотреть.',
    },
    page: {
      blockedTitle: (host: string) => `${host} запрещает встраивание`,
      blockedText:
        'Сайт не разрешает показывать свои страницы внутри других сайтов, и VYBE не обходит этот запрет.',
      blockedHint:
        'Откройте страницу на сайте и смотрите по общему таймкоду ниже — или выберите источник с автоматической синхронизацией: YouTube, Vimeo, VK Видео, Rutube или прямую ссылку на видеофайл.',
      openSite: 'Открыть на сайте',
      watchInTab: 'Смотреть в отдельной вкладке',
      backToFrame: 'Показать внутри VYBE',
      tabTitle: 'Вы смотрите в отдельной вкладке',
      tabText:
        'VYBE не управляет плеером чужого сайта. Запускайте и останавливайте видео там сами, сверяясь с общим таймкодом ниже.',
      frameUnknown: 'Не видите страницу? Сайт мог запретить встраивание — откройте её на сайте.',
      episodeHint: 'Следующая серия: ведущий вставляет ссылку на неё — она откроется у всех.',
    },
    manual: {
      title: 'Ручная синхронизация',
      roomTime: 'Общий таймкод',
      playing: 'идёт',
      paused: 'на паузе',
      countdown: (n: number) => `Старт через ${n}…`,
      pressPlay: 'Нажмите ▶ в плеере',
      start: 'Старт для всех',
      pause: 'Пауза для всех',
      setTime: 'Задать время',
      timeLabel: 'Время для всех (мм:сс)',
      timeInvalid: 'Введите время как 12:34 или 1:02:03',
      guestHint: 'Командами управляет ведущий — следите за таймкодом и уведомлениями.',
      explain:
        'Этот плеер не даёт VYBE управлять собой, поэтому пауза и перемотка не передаются автоматически. После «Старт для всех» и отсчёта 3-2-1 каждый сам нажимает ▶ в плеере на общем таймкоде; так же — пауза и перемотка.',
      notices: {
        play: (name: string, time: string) => `${name}: старт для всех с ${time}`,
        pause: (name: string, time: string) => `${name}: пауза на ${time}`,
        seek: (name: string, time: string) => `${name}: перемотка на ${time}`,
      },
    },
    autoplayBlocked: 'Браузер остановил автозапуск',
    autoplayAction: 'Нажмите, чтобы присоединиться к просмотру',
  },
  player: {
    play: 'Воспроизвести',
    pause: 'Пауза',
    mute: 'Выключить звук',
    unmute: 'Включить звук',
    fullscreen: 'Во весь экран',
    exitFullscreen: 'Выйти из полноэкранного режима',
    seek: 'Перемотка',
    volume: 'Громкость',
    noControl: 'Воспроизведением управляет ведущий',
    buffering: 'Буферизация…',
    react: 'Реакция',
    lag: {
      behind: (s: number) => `Отставание: ${s} с`,
      ahead: (s: number) => `Опережение: ${s} с`,
      slowLink: 'медленная загрузка',
      catchUp: 'Догнать',
      sync: 'Синхронизировать',
    },
  },
  chat: {
    placeholder: 'Сообщение…',
    send: 'Отправить',
    sending: 'Отправка…',
    failed: 'Не отправлено',
    retry: 'Повторить',
    empty: 'Сообщений пока нет. Начните разговор.',
    tooLong: (max: number) => `Не более ${max} символов`,
    system: {
      joined: (name: string) => `${name} присоединяется`,
      left: (name: string) => `${name} выходит`,
      removed: (name: string) => `${name} удалён(а) из комнаты`,
      sourceChanged: (name: string) => `${name} включает новое видео`,
      roleChanged: (name: string) => `Роль ${name} изменена`,
    },
    react: 'Добавить реакцию',
    newMessages: 'Новые сообщения',
    newMessagesCount: (n: number) => `Новые сообщения · ${n}`,
    unreadCount: (n: number) => `Непрочитанных: ${n}`,
    reply: 'Ответить',
    replyingTo: (name: string) => `Ответ для ${name}`,
    cancelReply: 'Отменить ответ',
    jumpToOriginal: 'Перейти к исходному сообщению',
    quoteUnavailable: 'Исходное сообщение больше недоступно',
    messageActions: 'Действия с сообщением',
    title: 'Чат',
    openChat: 'Открыть чат',
    hideChat: 'Скрыть чат',
    showOverVideo: 'Чат поверх видео',
    dock: 'Закрепить рядом с видео',
    floatingNotice: 'Чат открыт поверх видео',
  },
  call: {
    title: 'Звонок',
    micOn: 'Включить микрофон',
    micOff: 'Выключить микрофон',
    camOn: 'Включить камеру',
    camOff: 'Выключить камеру',
    collapse: 'Свернуть',
    expand: 'Развернуть',
    devices: 'Устройства',
    microphone: 'Микрофон',
    camera: 'Камера',
    defaultDevice: 'По умолчанию',
    dragHint: 'Перетащите, чтобы переместить',
    connecting: 'соединение…',
    failed: 'нет соединения',
    cameraOff: 'Камера выключена',
    disabledByRoom: 'Отключено в настройках комнаты',
    errors: {
      denied: {
        mic: 'Доступ к микрофону запрещён. Разрешите его в настройках браузера (значок замка в адресной строке).',
        cam: 'Доступ к камере запрещён. Разрешите его в настройках браузера (значок замка в адресной строке).',
      },
      not_found: {
        mic: 'Микрофон не найден. Подключите устройство и попробуйте снова.',
        cam: 'Камера не найдена. Подключите устройство и попробуйте снова.',
      },
      in_use: {
        mic: 'Микрофон занят другим приложением.',
        cam: 'Камера занята другим приложением.',
      },
      insecure: {
        mic: 'Микрофон доступен только по HTTPS.',
        cam: 'Камера доступна только по HTTPS.',
      },
      unknown: { mic: 'Не удалось включить микрофон.', cam: 'Не удалось включить камеру.' },
    },
    peerFailedHint: 'Не удалось соединиться напрямую. Для строгих сетей нужен TURN-сервер.',
  },
  notFound: { title: 'Страница не найдена', text: 'Такой страницы нет. Вернитесь на главную.' },
};

type Widen<T> = T extends string
  ? string
  : T extends (...args: infer A) => string
    ? (...args: A) => string
    : T extends readonly (infer U)[]
      ? readonly Widen<U>[]
      : { [K in keyof T]: Widen<T[K]> };

/** Every locale must provide exactly this shape. */
export type Messages = Widen<typeof ru>;
